import { useTranslation } from "react-i18next";
import { LiveStatus } from "../../features/messages/live/messagesHubClient";

/** The one line shown while a lost live connection is being re-opened; the poll covers meanwhile. */
const LiveReconnectingNotice = ({ status }: { status: LiveStatus }) => {
  const { t } = useTranslation();
  if (status !== "reconnecting") return null;
  return (
    <p role="status" className="mb-4 rounded-2xl bg-grey-95 p-3 text-sm text-grey-20 dark:bg-primary-20 dark:text-white">
      {t("messages.live.reconnecting")}
    </p>
  );
};

export default LiveReconnectingNotice;
